/* street-tokyo-full.js — Street Origins Tokyo Full Page (card-deck edition)
 * Requires: gsap.min.js loaded before this file.
 * Architecture: 3 fixed panels · hero → swipeable card deck → final CTA */
(function () {
  "use strict";

  function init() {
    if (typeof gsap === "undefined") {
      setTimeout(init, 80);
      return;
    }

    document.querySelectorAll("[data-stf2-root]").forEach(function (root) {
      if (root.dataset.stf2Init) return;
      root.dataset.stf2Init = "1";

      var sid = root.dataset.stf2Sid;
      var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      /* ── Lock body scroll ── */
      document.documentElement.classList.add("stf2-lock");
      document.body.classList.add("stf2-lock");

      /* ── Set background images from config ── */
      var cfgEl = root.querySelector("[data-stf2-config]");
      if (cfgEl) {
        var cfg = JSON.parse(cfgEl.textContent);
        var bgDay   = root.querySelector(".stf2-bg-day");
        var bgNight = root.querySelector(".stf2-bg-night");
        function applyBg() {
          var m = matchMedia("(max-width:992px)").matches;
          if (bgDay)   bgDay.style.backgroundImage   = "url('" + (m && cfg.bgDayM   ? cfg.bgDayM   : cfg.bgDay)   + "')";
          if (bgNight) bgNight.style.backgroundImage = "url('" + (m && cfg.bgNightM ? cfg.bgNightM : cfg.bgNight) + "')";
        }
        applyBg();
        window.addEventListener("resize", applyBg);
      }

      /* ── Element references ── */
      var heroPanel  = root.querySelector(".stf2-hero-panel");
      var deckPanel  = root.querySelector(".stf2-deck-panel");
      var deskPanel  = root.querySelector(".stf2-desk-parrl");
      var finalPanel = root.querySelector(".stf2-final-panel");
      var startBtn   = root.querySelector(".stf2-start-btn");
      var cards      = Array.prototype.slice.call(root.querySelectorAll(".stf2-swipe-card"));
      var dots       = Array.prototype.slice.call(root.querySelectorAll(".stf2-deck-progress i"));
      var swipeHint  = root.querySelector(".stf2-swipe-hint");
      var bgNightEl  = root.querySelector(".stf2-bg-night");
      var escapeBtn  = root.querySelector(".stf2-escape-btn");
      var bgTintEl   = root.querySelector(".stf2-bg-tint");
      var finalGlow   = root.querySelector(".stf2-final-glow");
      var finalBottle = root.querySelector(".stf2-final-bottle");
      var finalCard   = root.querySelector(".stf2-final-card");
      var replayBtn   = root.querySelector(".stf2-replay");
      var knowMoreBtn   = root.querySelector(".stf2-know-more");
      var cartBtn     = root.querySelector(".stf2-cart-btn");
      var cartCount   = root.querySelector(".stf2-cart-count");
      var ctaBtn      = root.querySelector(".stf2-final-cta");
      if (escapeBtn) gsap.set(escapeBtn, { autoAlpha: 0 }); 

      /* ── Cart drawer — move to body so it stays accessible under body lock ── */
      var drawer = document.querySelector("cart-drawer-component");
      if (drawer && drawer.offsetParent === null && drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }

      function refreshCartCount() {
        fetch("/cart.js")
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var n = c.item_count || 0;
            if (cartCount) {
              cartCount.textContent = n > 9 ? "9+" : n;
              cartCount.classList.toggle("has-items", n > 0);
            }
          }).catch(function () {});
      }
      refreshCartCount();
      document.addEventListener("cart:update", function () { setTimeout(refreshCartCount, 800); });

      function openCartDrawer() {
        var d = document.querySelector("cart-drawer-component");
        if (!d) { window.location.href = "/cart"; return; }
        var cartBtn = d.querySelector("button.header-actions__action");
        if (cartBtn) { cartBtn.dispatchEvent(new MouseEvent("click", { bubbles: true })); return; }
        if (typeof d.open === "function") d.open();
      }

      /* Cart icon click */
      if (cartBtn) {
        cartBtn.addEventListener("click", openCartDrawer);
      }

      /* Final CTA — add to cart then open drawer (or navigate if no variant) */
      if (ctaBtn) {
        ctaBtn.addEventListener("click", function () {
          var vid  = ctaBtn.getAttribute("data-variant-id");
          var href = ctaBtn.getAttribute("data-href");
          if (ctaBtn.disabled) return;
          if (!vid) { if (href) { window.location.href = href; } else { openCartDrawer(); } return; }
          ctaBtn.disabled = true;
          var orig = ctaBtn.textContent;
          ctaBtn.textContent = "Adding…";

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
          })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed");
            return r.json();
          })
          .then(function () {
            ctaBtn.textContent = "✓ Added";
            refreshCartCount();

            /* Refresh cart-items-component via Section Rendering API then open */
            var cartItemsEl = document.querySelector("cart-items-component");
            var sectionId   = cartItemsEl && cartItemsEl.dataset.sectionId;

            function afterRefresh() {
              openCartDrawer();
              setTimeout(function () {
                ctaBtn.textContent = orig;
                ctaBtn.disabled = false;
              }, 3000);
            }

            if (sectionId) {
              fetch("/?sections=" + sectionId)
                .then(function (r) { return r.json(); })
                .then(function (data) {
                  var html = data[sectionId];
                  if (html) {
                    var doc   = new DOMParser().parseFromString(html, "text/html");
                    var fresh = doc.querySelector("cart-items-component");
                    if (fresh && cartItemsEl) cartItemsEl.innerHTML = fresh.innerHTML;
                    var fh = doc.querySelector(".cart-drawer__heading");
                    var eh = document.querySelector(".cart-drawer__heading");
                    if (fh && eh) eh.innerHTML = fh.innerHTML;
                  }
                  afterRefresh();
                })
                .catch(afterRefresh);
            } else {
              afterRefresh();
            }
          })
          .catch(function () {
            ctaBtn.textContent = "Error — retry";
            ctaBtn.disabled = false;
            setTimeout(function () { ctaBtn.textContent = orig; }, 2500);
          });
        });
      }

      var totalCards  = cards.length;
      var currentCard = 0;
      var hintDone    = false;

      /* Stack: card[0] on top */
      cards.forEach(function (card, i) {
        card.style.zIndex = totalCards - i;
      });

      /* ── Progress dots ── */
      function setDot(idx) {
        dots.forEach(function (d, i) { d.classList.toggle("on", i === idx); });
      }

      var prevBtn = root.querySelector(".stf2-arrow-prev");
      var nextBtn = root.querySelector(".stf2-arrow-next");

      function updateArrows() {
        if (prevBtn) prevBtn.classList.toggle("is-hidden", currentCard === 0);
        if (nextBtn) nextBtn.classList.toggle("is-hidden", currentCard >= totalCards - 1);
      }
      updateArrows();

      /* ── Shared go-back logic (prev button + right swipe) ── */
      function goBack() {
        if (currentCard === 0) return;
        dismissHint();
        var current = cards[currentCard];
        var currentIdx = currentCard;

        // Boost z-index so current is on top while flying out
        current.style.zIndex = totalCards + 1;

        // Hide cards below so nothing bleeds through during exit
        for (var h = currentIdx + 1; h < totalCards; h++) {
          gsap.set(cards[h], { autoAlpha: 0 });
        }

        gsap.to(current, {
          x: window.innerWidth * 1.3,
          rotation: 15,
          duration: 0.35,
          ease: "power2.in",
          onComplete: function () {
            // Stay hidden — prev is still animating in; restore in prev's onComplete
            gsap.set(current, { x: 0, rotation: 0, autoAlpha: 0 });
            current.style.zIndex = totalCards - currentIdx;
            current.style.pointerEvents = "";
          }
        });

        currentCard--;
        var prev = cards[currentCard];
        prev.style.pointerEvents = "";
        gsap.set(prev, { x: -window.innerWidth * 1.3, rotation: -15, autoAlpha: 1 });
        gsap.to(prev, {
          x: 0, rotation: 0, autoAlpha: 1, duration: 0.4, ease: "power3.out",
          onComplete: function () {
            // Prev fully landed — now restore current and all cards below it
            for (var r = currentIdx; r < totalCards; r++) {
              gsap.set(cards[r], { autoAlpha: 1 });
            }
          }
        });

        setDot(currentCard);
        updateArrows();
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", goBack);
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          if (currentCard >= totalCards - 1) return;
          advanceCard(1);
        });
      }

      /* ── Dismiss swipe hint on first swipe ── */
      function dismissHint() {
        if (hintDone) return;
        hintDone = true;
        if (swipeHint) gsap.to(swipeHint, {
          autoAlpha: 0,
          duration: 0.3,
          onComplete: function () {
            swipeHint.style.display = "none";
          }
        });
      }

      /* ── Fly current card off and advance ── */
      function advanceCard(dirX) {
        if (currentCard >= totalCards) return;
        dismissHint();
        var card  = cards[currentCard];
        var flyX  = dirX < 0 ? -window.innerWidth * 1.3 : window.innerWidth * 1.3;
        var flyRot = dirX < 0 ? -25 : 25;

        gsap.to(card, {
          x: flyX,
          rotation: flyRot,
          autoAlpha: 0,
          duration: 0.38,
          ease: "power2.in",
          onComplete: function () {
            card.style.pointerEvents = "none";
            currentCard++;
            // Restore new current card and all below (hidden during drag)
            for (var i = currentCard; i < totalCards; i++) {
              gsap.set(cards[i], { autoAlpha: 1 });
            }
            if (currentCard < totalCards) {
              setDot(currentCard);
              updateArrows();
            } else {
              updateArrows();
              revealFinal();
            }
          }
        });
      }

      /* ── Show final panel ── */
      function revealFinal() {
        var activePanel = (window.matchMedia("(min-width: 721px)").matches && deskPanel) ? deskPanel : deckPanel;
        gsap.to(activePanel, {
          autoAlpha: 0,
          duration: 0.5,
          ease: "power2.inOut",
          onComplete: function () {
            gsap.to(finalPanel, { autoAlpha: 1, duration: 0.5, ease: "power2.inOut" });
            
            if (bgNightEl) gsap.to(bgNightEl, { opacity: 1, duration: 0.9 });
            if (bgTintEl)  gsap.to(bgTintEl,  { opacity: 0.45, duration: 0.9 });
            if (finalGlow)   gsap.to(finalGlow,   { opacity: 1, duration: 0.9, delay: 0.15 });
            if (finalBottle) {
              gsap.set(finalBottle, { xPercent: -50, yPercent: -50, scale: 0.72 });
              gsap.to(finalBottle, { opacity: 1, scale: 1, duration: 0.9, ease: "power3.out", delay: 0.1 });
            }
            if (finalCard) gsap.to(finalCard, { opacity: 1, duration: 0.6, delay: 0.4 });
            if (escapeBtn) gsap.to(escapeBtn, { autoAlpha: 1, duration: 0.6, delay: 0.3 });   // ← ADD THIS LINE
            if (replayBtn) replayBtn.style.display = "block";
            if (knowMoreBtn) knowMoreBtn.style.display = "block";
          }
        });
      }

      /* ── Replay / reset ── */
      if (replayBtn) {
        replayBtn.addEventListener("click", function () {
          gsap.to(finalPanel, {
            autoAlpha: 0,
            duration: 0.4,
            onComplete: function () {
              currentCard = 0;
              hintDone    = false;

              cards.forEach(function (card, i) {
                gsap.set(card, { x: 0, y: 0, rotation: 0, autoAlpha: 1 });
                card.style.pointerEvents = "";
                card.style.zIndex = totalCards - i;
              });
              setDot(0);
              updateArrows();

              if (swipeHint) {
                swipeHint.style.display = "";
                gsap.set(swipeHint, { autoAlpha: 1 });
              }
              if (bgNightEl)   gsap.set(bgNightEl,   { opacity: 0 });
              if (bgTintEl)    gsap.set(bgTintEl,    { opacity: 0 });
              if (finalGlow)   gsap.set(finalGlow,   { opacity: 0 });
              if (finalBottle) gsap.set(finalBottle, { opacity: 0, scale: 0.72 });
              if (finalCard)   gsap.set(finalCard,   { opacity: 0 });
              if (escapeBtn)   gsap.set(escapeBtn,   { autoAlpha: 0 });

              replayBtn.style.display = "none";
              if (knowMoreBtn) knowMoreBtn.style.display = "none";

              var isDesktop = window.matchMedia("(min-width: 721px)").matches;
              if (isDesktop && deskPanel) {
                gsap.set(deskPanel, { autoAlpha: 0 });
                deskPanel.scrollTop = 0;
                finalTriggered = false;
                heroActive = false;            // skip hero, go straight to desk panel
                gsap.to(deskPanel, { autoAlpha: 1, duration: 0.5 });
              } else {
                gsap.set(deckPanel, { autoAlpha: 0 });
                heroActive = false;            // skip hero, go straight to deck
                gsap.to(deckPanel, { autoAlpha: 1, duration: 0.5 });
              }
            }
          });
        });
      }

      /* ── Hero intro ── */
      if (!reduceMotion) {
        var logo   = heroPanel.querySelector(".stf2-hero-logo");
        var eyebrow = heroPanel.querySelector(".stf2-hero-eyebrow");
        var tag    = heroPanel.querySelector(".stf2-hero-tag");
        var escape = root.querySelector(".stf2-escape-btn");
        if (logo)    gsap.from(logo,    { autoAlpha: 0, scale: 0.9, y: 24, duration: 1.0, ease: "power3.out", delay: 0.2 });
        if (eyebrow) gsap.from(eyebrow, { autoAlpha: 0, y: -16,           duration: 0.8, ease: "power3.out", delay: 0.45 });
        if (tag)     gsap.from(tag,     { autoAlpha: 0, y:  16,           duration: 0.8, ease: "power3.out", delay: 0.55 });
        if (startBtn) gsap.from(startBtn, { autoAlpha: 0, y: 20,          duration: 0.7, ease: "power3.out", delay: 0.7 });
        //if (escape)  gsap.from(escape,  { autoAlpha: 0, x: -16,           duration: 0.7, ease: "power3.out", delay: 0.65 });
      }

      /* ── Start button ── */
    //   if (startBtn) {
    //     startBtn.addEventListener("click", function () {
    //       gsap.to(heroPanel, {
    //         autoAlpha: 0,
    //         duration: 0.5,
    //         ease: "power2.inOut",
    //         onComplete: function () {
    //           gsap.to(deckPanel, { autoAlpha: 1, duration: 0.5, ease: "power2.inOut" });
    //           if (!reduceMotion) {
    //             gsap.from(cards[0], { y: 60, autoAlpha: 0, duration: 0.6, ease: "power3.out", delay: 0.1 });
    //           }
    //         }
    //       });
    //     });
    //   }

          /* ── Enter deck: click on button OR swipe/drag anywhere on hero panel ── */
      var heroActive = true;

      function enterDeck() {
        if (!heroActive) return;
        heroActive = false;
        var isDesktop = window.matchMedia("(min-width: 721px)").matches;
        gsap.to(heroPanel, {
          autoAlpha: 0,
          duration: 0.5,
          ease: "power2.inOut",
          onComplete: function () {
            if (isDesktop && deskPanel) {
              gsap.to(deskPanel, { autoAlpha: 1, duration: 0.5, ease: "power2.inOut" });
            } else {
              gsap.to(deckPanel, { autoAlpha: 1, duration: 0.5, ease: "power2.inOut" });
              if (!reduceMotion) {
                gsap.from(cards[0], { y: 60, autoAlpha: 0, duration: 0.6, ease: "power3.out", delay: 0.1 });
              }
            }
          }
        });
      }

      if (startBtn) {
        startBtn.addEventListener("click", enterDeck);
      }

      /* Desktop: scroll down on hero triggers entry */
      root.addEventListener("wheel", function (e) {
        if (!heroActive) return;
        if (!window.matchMedia("(min-width: 721px)").matches) return;
        if (e.deltaY > 0) enterDeck();
      }, { passive: true });

      /* Desktop panel — scroll-driven parallax + auto-advance to final */
      if (deskPanel) {
        var finalTriggered = false;
        deskPanel.addEventListener("scroll", function () {
          var bandBgs = deskPanel.querySelectorAll(".band");
          bandBgs.forEach(function (band) {
            var bg = band.querySelector(".band-bg");
            if (!bg) return;
            var rect = band.getBoundingClientRect();
            var progress = Math.max(0, Math.min(1, -rect.top / deskPanel.clientHeight));
            bg.style.transform = "translateY(" + (progress * 18) + "%)";
          });
          var atBottom = deskPanel.scrollTop + deskPanel.clientHeight >= deskPanel.scrollHeight - 40;
          if (atBottom && !finalTriggered) {
            finalTriggered = true;
            revealFinal();
          }
        });
      }

      /* Swipe/drag gesture on the hero panel also triggers entry */
      var heroDragX = 0, heroDragY = 0, heroDragging = false;

      function heroDragStart(x, y) {
        if (!heroActive) return;
        heroDragging = true;
        heroDragX = x;
        heroDragY = y;
      }
      function heroDragEnd(x, y) {
        if (!heroDragging) return;
        heroDragging = false;
        var dx = x - heroDragX;
        var dy = y - heroDragY;
        if (Math.abs(dx) > 60 || Math.abs(dy) > 60) {
          enterDeck();
        }
      }

      heroPanel.addEventListener("mousedown", function (e) {
        heroDragStart(e.clientX, e.clientY);
      });
      window.addEventListener("mouseup", function (e) {
        heroDragEnd(e.clientX, e.clientY);
      });
      heroPanel.addEventListener("touchstart", function (e) {
        heroDragStart(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });
      heroPanel.addEventListener("touchend", function (e) {
        heroDragEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      }, { passive: true });

      /* ── Card drag/swipe handler ── */
      var dragCard   = null;
      var dragStartX = 0;
      var dragStartY = 0;

      function onDragStart(card, x, y) {
        if (!card) return;
        var idx = cards.indexOf(card);
        if (idx !== currentCard) return;
        gsap.killTweensOf(card);
        dragCard   = card;
        dragStartX = x;
        dragStartY = y;
      }

      function onDragMove(x, y) {
        if (!dragCard) return;
        var dx = x - dragStartX;
        var dy = y - dragStartY;
        gsap.set(dragCard, { x: dx, y: dy * 0.25, rotation: dx * 0.07 });
        // Right drag → hide cards below (don't reveal next); left drag → show them (reveal next card)
        var idx = cards.indexOf(dragCard);
        var below = dx > 0 ? 0 : 1;
        for (var i = idx + 1; i < totalCards; i++) {
          gsap.set(cards[i], { autoAlpha: below });
        }
      }

      function onDragEnd(x) {
        if (!dragCard) return;
        var dx   = x - dragStartX;
        var card = dragCard;
        dragCard = null;

        if (Math.abs(dx) > 75) {
          if (dx > 0) {
            // Right swipe → go back to previous card (or snap back if already first)
            if (currentCard > 0) {
              goBack();
            } else {
              gsap.to(card, { x: 0, y: 0, rotation: 0, duration: 0.45, ease: "elastic.out(1, 0.7)" });
            }
          } else {
            // Left swipe → advance to next card
            advanceCard(dx);
          }
        } else {
          gsap.to(card, { x: 0, y: 0, rotation: 0, duration: 0.45, ease: "elastic.out(1, 0.7)",
            onComplete: function () {
              // Restore cards below (hidden during drag)
              for (var i = currentCard + 1; i < totalCards; i++) {
                gsap.set(cards[i], { autoAlpha: 1 });
              }
            }
          });
        }
      }

      /* Mouse */
      root.addEventListener("mousedown", function (e) {
        var card = e.target.closest(".stf2-swipe-card");
        if (!card) return;
        e.preventDefault();
        onDragStart(card, e.clientX, e.clientY);
      });
      window.addEventListener("mousemove", function (e) {
        if (dragCard) onDragMove(e.clientX, e.clientY);
      });
      window.addEventListener("mouseup", function (e) {
        if (dragCard) onDragEnd(e.clientX);
      });

      /* Touch */
      root.addEventListener("touchstart", function (e) {
        var card = e.target.closest(".stf2-swipe-card");
        if (!card) return;
        e.preventDefault();
        onDragStart(card, e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: false });

      root.addEventListener("touchmove", function (e) {
        if (!dragCard) return;
        e.preventDefault();
        onDragMove(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: false });

      root.addEventListener("touchend", function (e) {
        if (!dragCard) return;
        onDragEnd(e.changedTouches[0].clientX);
      }, { passive: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
